import {Grid, Typography} from "@material-ui/core";
import React from "react";
import globalTheme from "../../../../../theme/globalTheme";
import {Link} from "react-router-dom";

export const ManagerQuotesRow = props => {
    const commonTheme = globalTheme._default();
    return (
        <Grid container key={props.data.related_quotes[props.index].uuid} style={{
            ...props.style,
            paddingLeft: 21,
            paddingTop: 13,
            paddingBottom: 13,
            paddingRight: 29,
            borderBottom: "1px #CFCFCF solid"
        }}>
            <Grid item xs={1}>
                <Typography
                    color="textPrimary"
                    variant="body1"
                    className={commonTheme.breakWrap}
                >
                    {props.data.related_quotes[props.index].status_name}
                </Typography>
            </Grid>
            <Grid item xs={4}>
                <Typography
                    color="textPrimary"
                    variant="body1"
                    className={commonTheme.breakWrap}
                >
                    <Link
                        to={'/manager/requests/' + props.data.requestUUID + '/quotes/' + props.data.related_quotes[props.index].uuid}>
                        <Typography className={commonTheme.link} variant="body1">
                            {props.data.related_quotes[props.index].name}
                        </Typography>
                    </Link>
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography
                    color="textPrimary"
                    variant="body1"
                    className={commonTheme.breakWrap}
                >
                    {props.data.related_quotes[props.index].number}
                </Typography>
            </Grid>
            <Grid item xs={2}>
                <Typography
                    color="textPrimary"
                    variant="body1"
                    className={commonTheme.breakWrap}
                >
                    {props.data.related_quotes[props.index].quote_at}
                </Typography>
            </Grid>
        </Grid>
    )
}
